/**
 * Helpers for judging whether a ProseMirror JSON doc carries user-visible text.
 */

function walkPmJson(node, visitText) {
    if (!node || typeof node !== 'object') return;
    if (node.type === 'text' && typeof node.text === 'string') {
        visitText(node.text);
        return;
    }
    const content = Array.isArray(node.content) ? node.content : [];
    for (const child of content) {
        walkPmJson(child, visitText);
    }
}

export function extractPmJsonPlainText(pmJson) {
    if (!pmJson) return '';
    const parts = [];
    walkPmJson(pmJson, (text) => parts.push(text));
    return parts.join('');
}

export function isSubstantivePmJson(pmJson) {
    return extractPmJsonPlainText(pmJson).trim().length > 0;
}
